import { makeAsyncActionCreators, makeActionCreator } from '../../helpers';
import { UsersActionTypes, ForgotPasswordActionTypes, RequestNewPasswordActionTypes } from '../types';

const fetchMoreUsers = makeAsyncActionCreators(
  UsersActionTypes.fetchMoreUsers,
  [
    'match',
    'project',
    'sort',
    'skip',
    'limit',
    'conditions',
  ],
  ['users'],
  ['error'],
);

const searchUsers = makeAsyncActionCreators(
  UsersActionTypes.searchUsers,
  [
    'match',
    'project',
    'sort',
    'conditions',
  ],
  ['users'],
  ['error'],
);

const deleteUser = makeAsyncActionCreators(
  UsersActionTypes.deleteUser,
  ['userId', 'navigate'],
  ['user'],
  ['error'],
);

const sendReinvite = makeAsyncActionCreators(
  UsersActionTypes.sendReinvite,
  ['userId'],
  ['user'],
  ['error'],
);

const getUserById = makeAsyncActionCreators(
  UsersActionTypes.getUserById,
  ['userId'],
  ['user'],
  ['error'],
);

const updateUser = makeAsyncActionCreators(
  UsersActionTypes.updateUser,
  ['userId', 'user', 'navigate'],
  ['user'],
  ['error'],
);

const getUsers = makeAsyncActionCreators(
  UsersActionTypes.getUsers,
  ['filters', 'pagination', 'sortBy'],
  ['users'],
  ['error'],
);

const getUsersForExcel = makeAsyncActionCreators(
  UsersActionTypes.getUsersForExcel,
  ['filters', 'sortBy'],
  ['users'],
  ['error'],
);

const addUser = makeAsyncActionCreators(
  UsersActionTypes.addUser,
  ['user', 'navigate'],
  [],
  ['error'],
);

const resetUser = makeActionCreator(UsersActionTypes.resetUser);

const getWritersMatch = makeAsyncActionCreators(
  UsersActionTypes.getWritersMatch,
  ['projectId', 'pagination', 'sortBy', 'filters'],
  ['writers'],
  ['error'],
);

const getExcelWritersMatch = makeAsyncActionCreators(
  UsersActionTypes.getExcelWritersMatch,
  ['projectId', 'sortBy', 'filters', 'userRole'],
  ['writers'],
  ['error'],
);

const getOfflineWritersMatch = makeAsyncActionCreators(
  UsersActionTypes.getOfflineWritersMatch,
  ['pagination', 'sortBy', 'filters', 'address'],
  ['writers'],
  ['error'],
);

const getExcelOfflineWritersMatch = makeAsyncActionCreators(
  UsersActionTypes.getExcelOfflineWritersMatch,
  ['sortBy', 'filters', 'address', 'userRole'],
  ['writers'],
  ['error'],
);

const addWriterToShortlist = makeAsyncActionCreators(
  UsersActionTypes.addWriterToShortlist,
  ['projectId', 'writerId'],
  ['writer'],
  ['error'],
);

const removeWriterFromShortlist = makeAsyncActionCreators(
  UsersActionTypes.removeWriterFromShortlist,
  ['projectId', 'writerId'],
  ['writer'],
  ['error'],
);

const getUserWithMiscData = makeAsyncActionCreators(
  UsersActionTypes.getUserWithMiscData,
  ['userId', 'pagination', 'shouldLoadMoreProjects'],
  ['user', 'projects', 'ratings', 'shouldLoadMoreProjects'],
  ['error'],
);

const toggleArchivingUser = makeAsyncActionCreators(
  UsersActionTypes.toggleArchivingUser,
  ['userId'],
  ['user'],
  ['error'],
);

const removeAvatar = makeAsyncActionCreators(
  UsersActionTypes.removeAvatar,
  ['userId', 'photoHandle'],
  ['user'],
  ['error'],
);

const addAvatarPhoto = makeAsyncActionCreators(
  UsersActionTypes.addAvatarPhoto,
  ['userId', 'photo'],
  ['user'],
  ['error'],
);

const removeUnsavedUserAvatar = makeAsyncActionCreators(
  UsersActionTypes.removeUnsavedUserAvatar,
  ['photoHandle'],
  [],
  ['error'],
);

const forgotPassword = makeAsyncActionCreators(
  ForgotPasswordActionTypes.forgotPassword,
  ['email'],
  [],
  ['error'],
);

const setupPassword = makeAsyncActionCreators(
  UsersActionTypes.setupPassword,
  ['email', 'token', 'password', 'isPolicyAccepted', 'navigate'],
  [],
  ['error'],
);

const getUserByToken = makeAsyncActionCreators(
  UsersActionTypes.getUserByToken,
  ['token'],
  ['user'],
  ['error'],
);
const updateHubspotProjectsCount = makeAsyncActionCreators(
  UsersActionTypes.updateHubspotProjectsCount,
  ['userId'],
  ['user'],
  ['error'],
);

const updateWritersProjectCount = makeAsyncActionCreators(
  UsersActionTypes.updateWritersProjectCount,
  [],
  ['writers'],
  ['error'],
);

const updateWritersDBSScreened = makeAsyncActionCreators(
  UsersActionTypes.updateWritersDBSScreened,
  [],
  [],
  ['error'],
);

const requestNewPassword = makeAsyncActionCreators(
  RequestNewPasswordActionTypes.requestNewPassword,
  ['token', 'email', 'isSetup'],
  [],
  ['error'],
);

export default {
  fetchMoreUsers,
  searchUsers,
  deleteUser,
  sendReinvite,
  getUserById,
  updateUser,
  addUser,
  resetUser,
  getUsers,
  getUsersForExcel,
  getWritersMatch,
  getOfflineWritersMatch,
  addWriterToShortlist,
  removeWriterFromShortlist,
  getUserWithMiscData,
  toggleArchivingUser,
  removeAvatar,
  addAvatarPhoto,
  getExcelWritersMatch,
  getExcelOfflineWritersMatch,
  removeUnsavedUserAvatar,
  forgotPassword,
  setupPassword,
  getUserByToken,
  updateHubspotProjectsCount,
  updateWritersProjectCount,
  updateWritersDBSScreened,
  requestNewPassword,
};
